import { Icon } from '@/components/Icon';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { monthLabel, type MonthOption } from './usageModel';

/** The month of the breakdown and the export. A menu of radio items (never a native select); UTC months. */
export function MonthPicker({ value, options, onChange }: { value: string; options: MonthOption[]; onChange: (month: string) => void }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" data-testid="usage-month" aria-label={`Month: ${monthLabel(value)}`} className="min-h-11 sm:min-h-9">
          <Icon name="calendar_month" size={18} />
          {monthLabel(value)}
          <Icon name="expand_more" size={18} className="text-subtle" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-48">
        <DropdownMenuRadioGroup value={value} onValueChange={onChange}>
          {options.map((o) => (
            <DropdownMenuRadioItem key={o.value} value={o.value} data-testid={`usage-month-${o.value}`} className="min-h-11 sm:min-h-8">
              {o.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
